import { render, staticRenderFns } from "./imageTxtNav.vue?vue&type=template&id=d8fb4f9a&scoped=true"
import script from "./imageTxtNav.vue?vue&type=script&lang=js"
export * from "./imageTxtNav.vue?vue&type=script&lang=js"
import style0 from "./imageTxtNav.vue?vue&type=style&index=0&id=d8fb4f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fb4f9a",
  null
  
)

export default component.exports